<template>
    <div class="navbar-container" :class="{ 'collapsed': isCollapsed }">
        <!-- Logo区域 -->
        <div class="navbar-logo" @click="toggleCollapse">
            <div class="logo-content">
                <img v-if="!isCollapsed" src="@/assets/images/logo-full.png" alt="Logo" class="logo-full">
                <img v-else src="@/assets/images/logo-mini.png" alt="Logo" class="logo-mini">
                <span v-if="!isCollapsed" class="logo-text">管理系统</span>
            </div>
            <div class="collapse-btn" @click.stop="toggleCollapse">
                <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            </div>
        </div>

        <!-- 菜单区域 -->
        <div class="navbar-menu" ref="navbarMenu">
            <div
                    v-for="(item, index) in getListData"
                    :key="item.id"
                    class="menu-item"
                    :class="{
          'active': activeMenu === item.id.toString(),
          'has-submenu': item.children && item.children.length > 0
        }"
                    :data-index="index"
                    @click="handleMenuSelect(item.id.toString())"
                    @mouseenter="handleMenuHover(item)"
            >
                <div class="menu-icon">
                    <i :class="item.icon"></i>
                </div>
                <div class="menu-text" v-if="!isCollapsed">
                    {{ item.name }}
                </div>
                <div class="menu-arrow" v-if="!isCollapsed && item.children && item.children.length > 0">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>

        <!-- 弹出式子菜单 -->
        <transition name="submenu-fade">
            <div
                    v-if="showSubmenu && activeSubmenu"
                    class="submenu-panel"
                    :class="{ 'collapsed': isCollapsed }"
                    :style="{ top: submenuTop + 'px' }"
                    @mouseenter="handleSubmenuEnter"
                    @mouseleave="handleSubmenuLeave"
                    ref="submenuPanel"
            >
                <div class="submenu-header">
                    <h3>{{ activeSubmenu.name }}</h3>
                    <div class="submenu-close" @click="closeSubmenu">
                        <i class="el-icon-close"></i>
                    </div>
                </div>

                <div class="submenu-content">
                    <div class="submenu-list">
                        <template v-for="subItem in activeSubmenu.children">
                            <!-- 有三级菜单的情况 -->
                            <div
                                    v-if="subItem.children && subItem.children.length > 0"
                                    :key="subItem.id"
                                    class="second-menu-item has-children"
                                    @mouseenter="handleSecondMenuHover(subItem)"
                                    @mouseleave="handleSecondMenuLeave"
                            >
                                <div class="second-menu-title" @click="handleSecondMenuClick(subItem)">
                                    <i :class="subItem.icon"></i>
                                    <span>{{ subItem.name }}</span>
                                    <i class="el-icon-arrow-right arrow-icon"></i>
                                </div>

                                <!-- 三级菜单 -->
                                <transition name="third-menu-fade">
                                    <div
                                            v-if="activeThirdMenu === subItem.id.toString()"
                                            class="third-menu-panel"
                                    >
                                        <div
                                                v-for="thirdItem in subItem.children"
                                                :key="thirdItem.id"
                                                class="third-menu-item"
                                                @click="handleThirdMenuClick(thirdItem)"
                                        >
                                            <i :class="thirdItem.icon"></i>
                                            <span>{{ thirdItem.name }}</span>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <!-- 只有二级菜单的情况 -->
                            <div
                                    v-else
                                    :key="subItem.id"
                                    class="second-menu-item"
                                    @click="handleSecondMenuClick(subItem)"
                            >
                                <i :class="subItem.icon"></i>
                                <span>{{ subItem.name }}</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "NavbarView",
        data() {
            return {
                isCollapsed: false,
                activeMenu: '',
                activeSubmenu: null,
                activeThirdMenu: null,
                showSubmenu: false,
                submenuTop: 0,
                getListData: [],
                hoverTimer: null,
                leaveTimer: null,
                clickMode: false // 标记是否是点击模式
            }
        },
        watch: {
            isCollapsed(newVal) {
                if (newVal) {
                    this.closeSubmenu();
                }
                this.$emit('collapse-change', newVal);

                // 重新计算菜单位置
                if (this.showSubmenu && this.activeSubmenu) {
                    this.$nextTick(() => {
                        this.calculateSubmenuPosition();
                    });
                }
            }
        },
        created() {
            this.menuData();
            const savedCollapsed = localStorage.getItem('menuCollapsed');
            if (savedCollapsed !== null) {
                this.isCollapsed = JSON.parse(savedCollapsed);
            }
        },
        mounted() {
            this.setDefaultActiveMenu();
            // 监听窗口点击，点击其他地方关闭子菜单
            document.addEventListener('click', this.handleDocumentClick);
        },
        beforeDestroy() {
            if (this.hoverTimer) clearTimeout(this.hoverTimer);
            if (this.leaveTimer) clearTimeout(this.leaveTimer);
            document.removeEventListener('click', this.handleDocumentClick);
        },
        methods: {
            async menuData() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    uid: sessionStorage.getItem('uid'),
                }

                let roles = JSON.parse(sessionStorage.getItem('roles'));
                let role_ids = [];
                for(let i = 0; i < roles.length; i++) {
                    role_ids.push(roles[i].id);
                }
                param.role_id = role_ids.join(',');

                try {
                    const res = await this.$axios.shopModuleList(param);
                    if(res.code == 200) {
                        this.getListData = res.data;
                        if (this.getListData.length > 0 && !this.activeMenu) {
                            this.activeMenu = this.getListData[0].id.toString();
                        }
                    }
                } catch (error) {
                    console.error('获取菜单数据失败:', error);
                }
            },

            handleMenuSelect(index) {
                this.clickMode = true;

                const menuItem = this.getListData.find(item => item.id.toString() === index);

                if (menuItem && menuItem.children && menuItem.children.length > 0) {
                    this.activeMenu = index;
                    this.activeSubmenu = menuItem;

                    // 如果是折叠状态，显示子菜单
                    if (this.isCollapsed) {
                        this.showSubmenu = !this.showSubmenu;
                    } else {
                        this.showSubmenu = true;
                    }

                    this.calculateSubmenuPosition();

                    // 重置点击模式
                    setTimeout(() => {
                        this.clickMode = false;
                    }, 100);
                } else if (menuItem && menuItem.path) {
                    // 如果菜单有直接路径，跳转
                    this.$router.push('/' + menuItem.path);
                    this.closeSubmenu();
                } else {
                    this.closeSubmenu();
                }
            },

            handleMenuHover(item) {
                // 如果是点击模式或折叠状态，不响应悬停
                if (this.clickMode || this.isCollapsed) return;

                if (this.leaveTimer) clearTimeout(this.leaveTimer);

                this.hoverTimer = setTimeout(() => {
                    if (item.children && item.children.length > 0) {
                        this.activeMenu = item.id.toString();
                        this.activeSubmenu = item;
                        this.showSubmenu = true;
                        this.calculateSubmenuPosition();
                    }
                }, 200);
            },

            calculateSubmenuPosition() {
                // 获取当前激活的菜单项
                const activeElement = document.querySelector('.menu-item.active');
                if (!activeElement) return;

                const rect = activeElement.getBoundingClientRect();
                const navbarRect = this.$el.getBoundingClientRect();

                // 计算相对于navbar的位置
                let top = rect.top - navbarRect.top;

                // 确保子菜单不会超出屏幕
                const submenuHeight = this.activeSubmenu.children ? this.activeSubmenu.children.length * 44 + 50 : 300; // 估算高度
                const windowHeight = window.innerHeight;

                if (top + submenuHeight > windowHeight) {
                    top = windowHeight - submenuHeight - 20; // 留出边距
                }

                if (top < 60) { // 避免与顶部重叠
                    top = 60;
                }

                this.submenuTop = top;
            },

            handleSubmenuEnter() {
                if (this.leaveTimer) clearTimeout(this.leaveTimer);
            },

            handleSubmenuLeave() {
                // 如果是折叠状态，不自动关闭子菜单
                if (this.isCollapsed) return;

                this.leaveTimer = setTimeout(() => {
                    const submenuPanel = document.querySelector('.submenu-panel:hover');
                    const secondMenu = document.querySelector('.second-menu-item:hover');
                    const thirdMenu = document.querySelector('.third-menu-panel:hover');

                    if (!submenuPanel && !secondMenu && !thirdMenu) {
                        this.showSubmenu = false;
                        this.activeThirdMenu = null;
                    }
                }, 300);
            },

            handleSecondMenuHover(subItem) {
                if (subItem.children && subItem.children.length > 0) {
                    this.activeThirdMenu = subItem.id.toString();
                }
            },

            handleSecondMenuLeave() {
                setTimeout(() => {
                    const thirdMenuPanel = document.querySelector('.third-menu-panel:hover');
                    const secondMenuItem = document.querySelector('.second-menu-item.has-children:hover');

                    if (!thirdMenuPanel && !secondMenuItem) {
                        this.activeThirdMenu = null;
                    }
                }, 100);
            },

            handleSecondMenuClick(subItem) {
                if (!subItem.children || subItem.children.length === 0) {
                    if (subItem.path) {
                        this.$router.push('/' + subItem.path);
                        this.closeSubmenu();
                    }
                }
            },

            handleThirdMenuClick(thirdItem) {
                if (thirdItem.path) {
                    this.$router.push('/' + thirdItem.path);
                    this.closeSubmenu();
                }
            },

            closeSubmenu() {
                this.showSubmenu = false;
                this.activeThirdMenu = null;
            },

            toggleCollapse() {
                this.isCollapsed = !this.isCollapsed;
                localStorage.setItem('menuCollapsed', this.isCollapsed);
            },

            setDefaultActiveMenu() {
                // 根据当前路由设置激活的菜单
                // 这里可以添加路由匹配逻辑
            },

            handleDocumentClick(event) {
                // 如果点击的不是菜单项或子菜单，则关闭子菜单
                const navbar = this.$el;
                const submenuPanel = this.$refs.submenuPanel;

                if (!navbar.contains(event.target) &&
                    (!submenuPanel || !submenuPanel.contains(event.target))) {
                    this.closeSubmenu();
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .navbar-container {
        width: 200px;
        height: 100%;
        background: linear-gradient(180deg, #304156 0%, #2b3446 100%);
        position: relative;
        display: flex;
        flex-direction: column;
        transition: width 0.3s ease;
        z-index: 1000;

        &.collapsed {
            width: 64px !important;

            .navbar-menu {
                .menu-text,
                .menu-arrow {
                    opacity: 0;
                    width: 0;
                    margin: 0;
                }
            }

            .collapse-btn i {
                transform: rotate(180deg);
            }
        }
    }

    /* Logo区域 */
    .navbar-logo {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background: #2b2f3a;
        border-bottom: 1px solid #404854;
        cursor: pointer;
        transition: all 0.3s;
        flex-shrink: 0;

        &:hover {
            background: #263445;
        }
    }

    .logo-content {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .logo-full {
        height: 32px;
        transition: all 0.3s;
    }

    .logo-mini {
        height: 32px;
        width: 32px;
        display: none;
    }

    .logo-text {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        white-space: nowrap;
        transition: all 0.3s;
    }

    /* 折叠状态下调整Logo区域 */
    .navbar-container.collapsed {
        .logo-content {
            justify-content: center;

            .logo-full {
                display: none;
            }

            .logo-mini {
                display: block;
            }

            .logo-text {
                opacity: 0;
                width: 0;
                margin-left: 0;
            }
        }

        .collapse-btn {
            display: none;
        }
    }

    .collapse-btn {
        color: #bfcbd9;
        font-size: 18px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.1);
        }

        i {
            transition: transform 0.3s;
        }
    }

    /* 菜单区域 */
    .navbar-menu {
        flex: 1;
        overflow-y: auto;
        padding: 10px 0;
        scrollbar-width: thin;
        scrollbar-color: #4a5568 transparent;
    }

    .navbar-menu::-webkit-scrollbar {
        width: 6px;
    }

    .navbar-menu::-webkit-scrollbar-track {
        background: transparent;
    }

    .navbar-menu::-webkit-scrollbar-thumb {
        background-color: #4a5568;
        border-radius: 3px;
    }

    .menu-item {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        color: #bfcbd9;
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        overflow: hidden; /* 防止内容溢出 */

        &:hover {
            background: #263445;
            color: #fff;

            .menu-arrow {
                opacity: 1;
            }
        }

        &.active {
            background: #409eff;
            color: #fff;

            &::after {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 3px;
                background: #fff;
            }

            .menu-arrow {
                color: #fff;
            }
        }
    }

    .menu-icon {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        flex-shrink: 0;
    }

    .menu-text {
        flex: 1;
        margin-left: 12px;
        font-size: 14px;
        white-space: nowrap;
        opacity: 1;
        transition: all 0.3s;
        text-align: left;
        min-width: 0; /* 确保文本不会撑开 */
    }

    .menu-arrow {
        color: #bfcbd9;
        font-size: 12px;
        opacity: 0.5;
        transition: all 0.3s;
        margin-left: 8px;
    }

    /* 弹出式子菜单 */
    .submenu-panel {
        position: fixed;
        left: 200px;
        top: 60px;
        bottom: auto;
        width: 220px;
        background: #fff;
        box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
        z-index: 1001;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border-left: 1px solid #e9ecef;
        border-radius: 0 8px 8px 0;
        max-height: 80vh;
        overflow-y: auto;

        /* 折叠状态下的位置 */
        &.collapsed {
            left: 64px !important;
        }
    }

    /* 子菜单动画 */
    .submenu-fade-enter-active,
    .submenu-fade-leave-active {
        transition: all 0.3s ease;
    }

    .submenu-fade-enter-from,
    .submenu-fade-leave-to {
        transform: translateX(-10px);
        opacity: 0;
    }

    .submenu-header {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 1;

        h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .submenu-close {
        color: #999;
        cursor: pointer;
        font-size: 16px;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
            color: #409eff;
            background: #e8f4ff;
        }
    }

    .submenu-content {
        flex: 1;
        overflow-y: auto;
        padding: 10px 0;
    }

    .submenu-list {
        padding: 0;
    }

    /* 二级菜单项 */
    .second-menu-item {
        padding: 0 20px;
        height: 44px;
        display: flex;
        align-items: center;
        color: #333;
        cursor: pointer;
        transition: all 0.3s;
        position: relative;

        &:hover {
            background: #f5f7fa;
            color: #409eff;

            .arrow-icon {
                color: #409eff;
            }
        }

        i:first-child {
            margin-right: 10px;
            font-size: 16px;
            color: #666;
        }

        span {
            flex: 1;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .arrow-icon {
            margin-left: 8px;
            font-size: 12px;
            color: #999;
            transition: all 0.3s;
        }
    }

    /* 二级菜单项（包含三级菜单） */
    .second-menu-item.has-children {
        position: relative;

        &:hover {
            .third-menu-panel {
                display: block;
            }
        }
    }

    /* 三级菜单面板 */
    .third-menu-panel {
        position: absolute;
        left: 100%;
        top: 0;
        width: 200px;
        background: #fff;
        box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
        border-left: 1px solid #e9ecef;
        z-index: 1002;
        max-height: 300px;
        overflow-y: auto;
        display: none;
        padding: 8px 0;
        border-radius: 0 8px 8px 0;
    }

    /* 三级菜单动画 */
    .third-menu-fade-enter-active,
    .third-menu-fade-leave-active {
        transition: all 0.3s ease;
    }

    .third-menu-fade-enter-from,
    .third-menu-fade-leave-to {
        transform: translateX(-10px);
        opacity: 0;
    }

    /* 三级菜单项 */
    .third-menu-item {
        padding: 0 20px;
        height: 40px;
        display: flex;
        align-items: center;
        color: #666;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            background: #f5f7fa;
            color: #409eff;
        }

        i {
            margin-right: 10px;
            font-size: 14px;
        }

        span {
            font-size: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    /* 滚动条样式 */
    .submenu-content::-webkit-scrollbar,
    .third-menu-panel::-webkit-scrollbar {
        width: 6px;
    }

    .submenu-content::-webkit-scrollbar-track,
    .third-menu-panel::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    .submenu-content::-webkit-scrollbar-thumb,
    .third-menu-panel::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    .submenu-content::-webkit-scrollbar-thumb:hover,
    .third-menu-panel::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    /* 响应式设计 */
    @media screen and (max-width: 992px) {
        .navbar-container {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            z-index: 1000;

            &.collapsed {
                transform: translateX(-100%);
            }
        }

        .submenu-panel {
            left: 200px;
            top: 0;
            z-index: 1001;

            &.collapsed {
                left: 64px !important;
            }
        }

        .third-menu-panel {
            left: 220px;
        }
    }
</style>
